
export default {
  data () { return { mounted: false, details: false, analytics: false } },
  watch: {
    '$consent.state.open' (open) {
      if (open) {
        this.analytics = this.$consent.state.analytics
        this.details = this.$consent.state.decided
        this.$nextTick(() => { if (this.$refs.heading) this.$refs.heading.focus() })
      }
    }
  },
  mounted () { this.mounted = true; this.analytics = this.$consent.state.analytics },
  methods: {
    close () { this.$consent.state.open = false },
    save (analytics) { this.$consent.save(analytics); this.details = false }
  }
}
